import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Chip,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { unusedItems } from '../../../mocks/data/itemRationalisationData';

/** Unused items - not ordered recently and not used in any recipe. "Retire" only updates
 * local UI state - no backend persistence exists for item retirement yet. */
const UnusedItemsTab = () => {
  const { t } = useTranslation('productManagement');
  const [retired, setRetired] = useState<Set<string>>(new Set());

  return (
    <Stack spacing={2}>
      <Typography variant="textSM"
        color="text.secondary">
        {t('rationalisation.unusedIntro', 'Items with no recent orders and no recipe usage - candidates for retirement.')}
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{t('itemNumber', 'Item Number')}</TableCell>
            <TableCell>{t('description', 'Description')}</TableCell>
            <TableCell>{t('rationalisation.lastOrdered', 'Last ordered')}</TableCell>
            <TableCell>{t('rationalisation.usedInRecipe', 'Used in recipe')}</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {unusedItems.map((item) => (
            <TableRow key={item.itemNumber}>
              <TableCell>{item.itemNumber}</TableCell>
              <TableCell>{item.description}</TableCell>
              <TableCell>{item.lastOrderedDate ?? t('rationalisation.neverOrdered', 'Never ordered')}</TableCell>
              <TableCell>
                <Chip
                  label={item.usedInRecipe ? t('yes', 'Yes') : t('no', 'No')}
                  size="small"
                  color={item.usedInRecipe ? 'warning' : 'default'}
                  variant="outlined"
                />
              </TableCell>
              <TableCell>
                {retired.has(item.itemNumber) ? (
                  <Chip label={t('rationalisation.retired', 'Retired')}
                    color="success"
                    size="small" />
                ) : (
                  <Button
                    variant="secondary"
                    size="md"
                    disabled={item.usedInRecipe}
                    onClick={() => setRetired((prev) => new Set(prev).add(item.itemNumber))}
                  >
                    {t('rationalisation.retireItem', 'Retire')}
                  </Button>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Stack>
  );
};

export default UnusedItemsTab;
